import Vue from 'vue';
import {ApplicationActions, EditDocumentSeedRequest, IssueDocumentDetailsApiModel} from "@/api-client";
import _ from "underscore";

export default abstract class IssueDocumentInnerComponent extends Vue {
    abstract initialEditModel : EditDocumentSeedRequest; // Inheritor must set this in MOUNTED lifecycle for "hasEdits" comparison to work.
    abstract getEditModel() : EditDocumentSeedRequest
    abstract issueDocumentDetails : IssueDocumentDetailsApiModel
    abstract actions : ApplicationActions;

    public hasEdits() {
        if (this.isReadOnly)
            return false;
        
        const isInitialSameAsCurrent = _.isEqual(this.initialEditModel, this.getEditModel());
        return !isInitialSameAsCurrent;
    }

    get isReadOnly() {
        return !this.actions.canFillDocumentSeed;
    }
}